export default "__VITE_ASSET__iWqrNTGS__"